import Proptypes from 'prop-types'
import { addBrToText } from 'utils'

import { StyledSubtitleh2, StyledSubtitleh3 } from './styles'

export const Subtitle = ({ text, subtiltleSize, style }) => (
  <>
    {subtiltleSize === 'h3'
      ? <StyledSubtitleh3 style={style}>{addBrToText(text, 'part-txt')}</StyledSubtitleh3>
      : <StyledSubtitleh2 style={style}>{addBrToText(text, 'part-txt')}</StyledSubtitleh2>
    }
  </>
)

Subtitle.propTypes = {
  text: Proptypes.any,
  subtitleSize: Proptypes.any,
  style: Proptypes.object
}

export default Subtitle
